import { ZERO } from "utils/constants";

import { IBusinessStatsData } from "./types";

export enum BusinessUserManagementQueryKeys {
  GET_BUSINESS_STATS = "get-business-stats",
  GET_BUSINESS_DETAILS = "get-business-details",
}

export const DEFAULT_BUSINESSES_STATS: IBusinessStatsData = {
  active: ZERO,
  inactive: ZERO,
  total: ZERO,
  deactivated: ZERO,
};
